import * as React from 'react';
import { connect } from 'react-redux';
import { IBasePageProps } from '../../configuration/IConfiguration';
import { bindActionCreators } from 'redux';
import { IAppState } from '../../../../app';
import * as AdminActionCreators from "../../../../actions/admin.actions";
import * as DashboardActionCreators from "../../../../actions/dashboard.actions";
import * as DTOS from "../../../../FeralScan.dtos";
import { LocalForm, Control } from 'react-redux-form';
import FileList from '../../../File/FileList';

type PageAdminFilesProps = {

}

type PageAdminFilesActions = {
}

type PageAdminFilesRouteParams = {
}

type PageAdminFilesQueryParams = {
}

type PageAdminFilesPropsMapped = {
    files: DTOS.FileRecord[];
    filesLoading: boolean;
    fileDeleting: boolean;
}

type PageAdminFilesActionsMapped = {
    searchFiles: typeof AdminActionCreators.searchFilesRequest;
    deleteFile: typeof DashboardActionCreators.deleteFileRequest;
}

type PageAdminFilesAllPropsInherited = PageAdminFilesProps & PageAdminFilesActions;
type PageAdminFilesAllPropsMapped = PageAdminFilesPropsMapped & PageAdminFilesActionsMapped;

type PageAdminFilesAllProps = IBasePageProps<PageAdminFilesRouteParams, PageAdminFilesQueryParams> & Partial<PageAdminFilesAllPropsMapped> & PageAdminFilesAllPropsInherited;

interface IPageAdminFilesState {
}

class PageAdminFiles extends React.Component<PageAdminFilesAllProps, IPageAdminFilesState> {
    constructor(props, context) {
        super(props, context);

        this.onDeleteClicked = this.onDeleteClicked.bind(this);
    }

    componentDidMount() {
        this.props.searchFiles(undefined);
    }

    componentDidUpdate(prevProps: PageAdminFilesAllProps){
        if(prevProps.fileDeleting && !this.props.fileDeleting){
            this.props.searchFiles(undefined);
        }
    }

    onSubmit(search) {
        this.props.searchFiles(search.searchText);
    }

    onDeleteClicked(plotEventId) {
        this.setState({ showDeleteModal: true, deletePlotEventId: plotEventId });
    }

    render() {

        const fileSearchForm = <LocalForm
            model="search"
            onSubmit={search =>
                this.onSubmit(search)
            }
            validateOn="submit"
            className="form form-inline col-12 my-2"
        >
            <div className="form-group form-inline">
                <Control.text
                    model=".searchText"
                    id="searchText"
                    placeholder="Search"
                    className="form-control"
                    maxLength={50}
                />
            </div>
            <div className="form-group form-inline px-3">
                <label className="">Deleted: </label>
                <Control.checkbox
                    model=".includeObsolete"
                    id="includeObsolete"
                    className="form-control ml-2"
                    defaultChecked={false}
                />
            </div>
            <button className="btn btn-lg btn-primary ml-1">Search</button>
        </LocalForm>;



        return (<div className="row m-3">
            <h2>Administration Dashboard</h2>
            {fileSearchForm}
            <hr className="w-100" />
            <FileList 
                className="col-12 mt-2"
                dateTimeFormat={this.props.defaultDateTimeFormat}
                files={this.props.files}
                filesLoading={this.props.filesLoading || this.props.fileDeleting}
                hidePaginationControls={false}
                onDeleteFile={this.props.deleteFile}
            />
        </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: PageAdminFilesAllProps): PageAdminFilesPropsMapped => {

    return {
        files: state.admin.files,
        filesLoading: state.admin.filesLoading,
        fileDeleting: state.file.fileDeleting
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators<PageAdminFilesActionsMapped>({
        searchFiles: AdminActionCreators.searchFilesRequest,
        deleteFile: DashboardActionCreators.deleteFileRequest
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PageAdminFiles);